import { useMemo } from 'react';

export const useTruthyCount = (values: readonly unknown[]): number => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo(() => values.filter(Boolean).length, [...values]);
};
